<template>
    <div class="dealer" style="display: table-cell;vertical-align: middle;text-align: center">
        <!-- ============= 顶部背景图 ============= -->
        <div>
            <img src="../../assets/images/dealer/banner.png" style="width: 100%;display: block">
        </div>

        <div class="dealer-componys" style="height: 80px;width: 100%;text-align: center;background-color:  #F0F0F0">
            <ul style="list-style-type:none;cursor:pointer;line-height: 80px;text-align: center;margin: 0 auto;padding: 0;height: 80px;width: 900px">
                <li v-for="(item,index) in items" :key="index" :class="{'selected':flag == index}" style="float: left;height: 80px;width: 450px;font-size: 24px" @click="getCompanyData(index)">{{item.title}}</li>
            </ul>
        </div>

        <div style="height: 360px;background-color: #F0F0F0;position: relative;line-height: 45px;padding-top: 60px">
            <img v-show="deJiTongShow" src="../../assets/images/dealer/Bitmap.png" style="display: block;margin-left: 40%">
            <p v-show="deJiTongShow" style="width: 960px;margin: 0 auto;color: rgba(51,51,51,1);">深圳得技通电子有限公司(Shenzhen Dejitong Electronics Co.,Ltd.)，位于深圳电子及商务的中心地带——赛格广场，创立于1990年3月。是一家专业经营单片机,仿真器和IC测试产品为主导的企业。 得技通公司的合作伙伴有:台湾河洛、台湾MICETEK、台湾玄积公司、北京闻亭科技、南京万利、南京西尔特、北京三环、福州高奇、中颖电子、广州天宇、 广州周立功等厂家建立密切合作关系，产品主要涉及MCS-51、PIC、DSP、ARM等系列仿真器以及各类通用编程器、逻辑分析仪、IC 插座及实验板等。公司倡导“以人为本，团队为体概念”的管理方针，销售中提倡“以质量和信用取胜，以完善的售后服务为后盾”的经营方针，以专业的技术和服务回报客户。</p>
            <p v-show="shenZhenShow" style="width: 960px;margin: 0 auto;color: rgba(51,51,51,1);">中颖电子本着专业专精的精神，专注于单片机(MCU)产品集成电路设计。MCU母体包括4-bit OTP/MASK MCU、8-bit OTP/MASK MCU、8-bit FLASH MCU，主要应用于各种小家电、白色家电、黑色家电、汽车电子周边、运动器材、医疗保健、四表(水、电、气、暖) 、仪器仪表、安防、电源控制、马达控制、工业控制、变频、数码电机、计算机键盘、鼠标、网络音乐(便携式、车载、床头音响)、无线儿童监控器、无线耳机/喇叭/门铃。同时，在扩大家电及计算机数码产品的基础上，又扩充了OLED、电池管理等绿色能源系列产品，以环保节能的先进理念揭开新的篇章。</p>
        </div>

        <div class="dealer-location" style="height: 120px;text-align: center">
            <div style="margin-top: 80px">
                <span >|</span>
                <span style="margin-left: 40px;cursor: pointer" @click="reload">深圳</span>
                <span style="margin-left: 40px;cursor: pointer" >|</span>
                <span style="margin-left: 40px;cursor: pointer" @click="reload">北京</span>
                <span style="margin-left: 40px;cursor: pointer" >|</span>
                <span style="margin-left: 40px;cursor: pointer" @click="reload">苏州</span>
                <span style="margin-left: 40px;cursor: pointer" >|</span>
                <span style="margin-left: 40px;cursor: pointer" @click="reload">沈阳</span>
                <span style="margin-left: 40px;cursor: pointer" >|</span>
                <span style="margin-left: 40px;cursor: pointer" @click="reload">广州</span>
                <span style="margin-left: 40px;cursor: pointer" >|</span>
                <span style="margin-left: 40px;cursor: pointer" @click="reload">成都</span>
                <span style="margin-left: 40px;cursor: pointer" >|</span>
                <span style="margin-left: 40px;cursor: pointer" @click="reload">上海</span>
                <span style="margin-left: 40px;cursor: pointer" >|</span>
                <span style="margin-left: 40px;cursor: pointer" @click="reload">杭州</span>
                <span style="margin-left: 40px;cursor: pointer" >|</span>
            </div>
        </div>

          <div class="local-department" style="height: 240px;text-align: center;display: inline-block">
              <div style="background-color: rgba(239,245,255,1);width: 1200px;height: 40px;">
                  <div style="padding-top: 8px">深圳一部</div>
              </div>

              <div><el-divider></el-divider></div>

              <el-table
                  :data="tableData1"
                  border
                  style="width: 1200px;text-align: center;">
                  <el-table-column align="center" prop="address">
                      <template slot="header" slot-scope="scope" >
                          <span style="font-size: 16px">地址</span>
                      </template>
                  </el-table-column>

                  <el-table-column align="center" prop="phone" width="240">
                      <template slot="header" slot-scope="scope">
                         <span style="font-size: 16px">电话</span>
                      </template>
                  </el-table-column>

                  <el-table-column align="center" prop="fax">
                      <template slot="header" slot-scope="scope">
                         <span style="font-size: 16px">传真</span>
                      </template>
                  </el-table-column>

                  <el-table-column align="center" prop="email">
                      <template slot="header" slot-scope="scope">
                         <span style="font-size: 16px">E-mail</span>
                      </template>
                  </el-table-column>
             </el-table>
          </div>

          <div class="local-department" style="height: 240px;text-align: center;display: inline-block">
              <div style="background-color: rgba(239,245,255,1);width: 1200px;height: 40px;">
                <div style="padding-top: 8px">深圳二部</div>
              </div>

              <div><el-divider></el-divider></div>

              <el-table
                    :data="tableData2"
                    border
                    style="width: 1200px;text-align: center;">
                    <el-table-column align="center" prop="address">
                        <template slot="header" slot-scope="scope" >
                            <span style="font-size: 16px">地址</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" prop="phone" width="240">
                        <template slot="header" slot-scope="scope">
                          <span style="font-size: 16px">电话</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" prop="fax">
                        <template slot="header" slot-scope="scope">
                          <span style="font-size: 16px">传真</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" prop="email">
                        <template slot="header" slot-scope="scope">
                          <span style="font-size: 16px">E-mail</span>
                        </template>
                      </el-table-column>
              </el-table>
        </div>

          <div class="local-department" style="height: 240px;text-align: center;display: inline-block">
            <div style="background-color: rgba(239,245,255,1);width: 1200px;height: 40px;">
              <div style="padding-top: 8px">深圳三部</div>
            </div>

            <div><el-divider></el-divider></div>

            <el-table
              :data="tableData3"
              border
              style="width: 1200px;text-align: center;">
              <el-table-column align="center" prop="address">
                <template slot="header" slot-scope="scope" >
                  <span style="font-size: 16px">地址</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="phone" width="240">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">电话</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="fax">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">传真</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="email">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">E-mail</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="local-department" style="height: 240px;text-align: center;display: inline-block">
            <div style="background-color: rgba(239,245,255,1);width: 1200px;height: 40px;">
              <div style="padding-top: 8px">深圳四部</div>
            </div>

            <div><el-divider></el-divider></div>

            <el-table
              :data="tableData4"
              border
              style="width: 1200px;text-align: center;">
              <el-table-column align="center" prop="address">
                <template slot="header" slot-scope="scope" >
                  <span style="font-size: 16px">地址</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="phone" width="240">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">电话</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="fax">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">传真</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="email">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">E-mail</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="local-department" style="height: 240px;text-align: center;display: inline-block">
            <div style="background-color: rgba(239,245,255,1);width: 1200px;height: 40px;">
              <div style="padding-top: 8px">深圳五部</div>
            </div>

            <div><el-divider></el-divider></div>

            <el-table
              :data="tableData5"
              border
              style="width: 1200px;text-align: center;">
              <el-table-column align="center" prop="address">
                <template slot="header" slot-scope="scope" >
                  <span style="font-size: 16px">地址</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="phone" width="240">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">电话</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="fax">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">传真</span>
                </template>
              </el-table-column>

              <el-table-column align="center" prop="email">
                <template slot="header" slot-scope="scope">
                  <span style="font-size: 16px">E-mail</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                deJiTongShow: true,
                shenZhenShow: false,
                flag: -1,
                items: [{title: '深圳得技通电子有限公司'},{title: '深圳公司'}],
                tableData1: [{
                    address: '深圳市深南中路赛格广场37楼3703室 ',
                    phone: '0755-61361234   0755-83665281   0755-83665282   0755-83665341',
                    fax: '0755-83665342',
                    email: 'dejitong@segit.com.cn',
                }],
                tableData2: [{
                    address: '深圳市赛格电子市场七楼7330室  ',
                    phone: '0755-83681447 0755-61361222 0755-33085447 ',
                    fax: '0755-83681447',
                    email: '-',
                }],
                tableData3: [{
                    address: '深圳市赛格电子市场三楼3B35柜 ',
                    phone: '0755-83291449 0755-83469230 ',
                    fax: '0755-83681644',
                    email: '-',
                }],
                tableData4: [{
                    address: '深圳市华强电子世界一栋二楼 11B022柜(手扶电梯口) ',
                    phone: '0755-83291449 0755-83469230 ',
                    fax: '0755-83291449',
                    email: '-',
                }],
                tableData5: [{
                    address: '深圳市华强电子世界二栋一楼 20A257 ',
                    phone: '0755-83687350 ',
                    fax: '0755-83687350',
                    email: '-',
                }]
              }
        },
        mounted:function(){
            this.getCompanyData(0);
        },
        methods: {
            getCompanyData:function (index) {
                this.flag = index;
                if(index === 0){
                    this.deJiTongShow = true;
                    this.shenZhenShow = false;
                }
                else if(index === 1){
                    this.deJiTongShow = false;
                    this.shenZhenShow = true;
                }
            },
            reload:function () {
                window.location.reload();
            }
        },
    }
</script>

<style>
    .dealer .local-department .el-divider--horizontal {height: 1px;margin: 0;background: rgba(74,144,226,1);width: 1200px;}
    .dealer .dealer-compony  { height: 80px;width: 100%;line-height:30px;background-color: #F0F0F0;text-align: center }
    .dealer .dealer-componys-li:hover { background-color: #fff }
    .dealer .selected { background-color: #fff }
</style>



// WEBPACK FOOTER //
// src/pages/dealer/dealer.vue